 export const config = {
    fullNodeUrl: "https://reverse-proxy.omnistar.io/mainnet/full-node",
    proxyUrl: "https://reverse-proxy.omnistar.io/mainnet/proxy",
    nodeUrl: "https://reverse-proxy.omnistar.io/mainnet/node",
    termsConditionsUrl: "https://terms.docs.wikey.io",
    privacyPolicyUrl: "https://terms.docs.wikey.io",
    // host: 'https://proxy.omnistar.io',
    appStoreUrl: "https://open.wikey.io",
    playStoreUrl: "https://open.wikey.io",
    mobileLinkUrl: import.meta.env?.VITE_PROJECT_MOBILE_LINK_URL || "sample://open.my.app/walletconnect", //"https://open.wikey.io/walletconnect"
    safeMotherAddress: "omnistar1u65s9n33egdg35d370jsxv26e2pm6epg2ggcpt",
    nodeLab: '9093',
    nodeLabName: 'mainnet',
}
 // mainnet : 9093, 8083
